import { apiClient } from '../api/client'
import { getTelegramUserId } from './telegram'
import { getAnalyticsContext } from './analytics'

export const INSUFFICIENT_CREDITS_MESSAGE = '请充值解锁更多功能'
export const INSUFFICIENT_CREDITS_MESSAGE_EN = 'Please recharge to unlock more features'

function getInsufficientCreditsMessage() {
  return localStorage.getItem('app_lang') !== 'zh'
    ? INSUFFICIENT_CREDITS_MESSAGE_EN
    : INSUFFICIENT_CREDITS_MESSAGE
}

interface ChargeResponse {
  success: boolean
  error?: string
  balance: number
  spent: number
  amount: number
  deduplicated?: boolean
}

const pendingCharges = new Map<string, Promise<ChargeResponse>>()

export async function chargeCredit(
  action: string,
  targetId = '',
  description = action,
  amount = 1
): Promise<ChargeResponse> {
  const chargeKey = `${action}:${targetId}:${amount}`
  const pending = pendingCharges.get(chargeKey)
  if (pending) return pending

  const request = apiClient.post<ChargeResponse>('/api/user/charge', {
    chat_id: getTelegramUserId(),
    action,
    target_id: targetId,
    amount,
    description,
    analytics_context: getAnalyticsContext(),
  }).finally(() => {
    pendingCharges.delete(chargeKey)
  })

  pendingCharges.set(chargeKey, request)
  return request
}

export async function requireCredit(
  action: string,
  targetId = '',
  description = action,
  onBlocked?: (message: string) => void,
  amount = 1
) {
  const result = await chargeCredit(action, targetId, description, amount)
  if (!result.success) {
    onBlocked?.(result.error || getInsufficientCreditsMessage())
    return false
  }
  return true
}
